import { useApolloClient } from '@apollo/client/react';

import {
  type ReportComponentProps,
  useReportContext,
} from '@modules/_shared/components/report-editor/ReportEditorContext';
import { ListingPropertyImages } from '@modules/listings/ListingPropertyImages/ListingPropertyImages';
import type { CMAReportType } from '@modules/reports/cma-reports/CMAReportEditor/CMAReportEditor';
import { STEP_COVER_PHOTO_CMA_FRAGMENT } from '@modules/reports/cma-reports/cmaReportsQueries';
import { FooterActionsComponentWithoutForm } from '@modules/reports/shared/FooterActionsComponentWithoutForm';
import { useUpdateCmaReport } from '@modules/reports/shared/utils';

const StepPhotosCMA = (props: ReportComponentProps) => {
  const { data } = useReportContext();
  const client = useApolloClient();
  const reportData = data as CMAReportType;

  const [updateCmaReport, updating] = useUpdateCmaReport(
    reportData.id,
    'page-photos',
  );

  return (
    <>
      <ListingPropertyImages
        propertyId={reportData.property.id}
        canEditImagesMeta={false}
        canOpenRightPanel={false}
        onUpdate={() => {
          updateCmaReport({});
        }}
        onAdd={newImages => {
          client.cache.updateFragment(
            {
              id: `cma_reports:${reportData.id}`,
              fragment: STEP_COVER_PHOTO_CMA_FRAGMENT,
              fragmentName: 'StepCoverPhotoCma',
            },
            data => {
              if (!data) {
                return null;
              }

              const existingsImages = data.property?.property_images ?? [];
              const propertyImages = [...existingsImages, ...newImages];

              return {
                ...data,
                property: {
                  ...data.property,
                  property_images: propertyImages,
                },
              };
            },
          );

          updateCmaReport({});
        }}
      />

      <FooterActionsComponentWithoutForm updating={updating} {...props} />
    </>
  );
};

export default StepPhotosCMA;
